export const environment = {
  production: true,
  buildId: '2690611236218491',
  configFile: 'config.json',
};
